import React from 'react'
import styled, { css } from 'styled-components'

const StyledAlert = styled.div`
    position: relative;
    padding: 0.75rem 1.25rem;
    margin-bottom: 1rem;
    border: 1px solid transparent;
    border-radius: 0.25rem;

    ${(props) =>
        props.variant === 'primary' &&
        css`
            color: #004085;
            background-color: #cce5ff;
            border-color: #b8daff;
        `}

    ${(props) =>
        props.variant === 'secondary' &&
        css`
            color: #383d41;
            background-color: #e2e3e5;
            border-color: #d6d8db;
        `}

  ${(props) =>
        props.variant === 'success' &&
        css`
            color: #155724;
            background-color: #d4edda;
            border-color: #c3e6cb;
        `}

  ${(props) =>
        props.variant === 'danger' &&
        css`
            color: #721c24;
            background-color: #f8d7da;
            border-color: #f5c6cb;
        `}

  ${(props) =>
        props.variant === 'warning' &&
        css`
            color: #856404;
            background-color: #fff3cd;
            border-color: #ffeeba;
        `}

  ${(props) =>
        props.variant === 'info' &&
        css`
            color: #0c5460;
            background-color: #d1ecf1;
            border-color: #bee5eb;
        `}
`

const Alert = ({ children, variant = 'primary', ...props }) => {
    return (
        <StyledAlert variant={variant} {...props}>
            {children}
        </StyledAlert>
    )
}

export default Alert
